<template>
    <div>
        <el-drawer title="新增/编辑计划" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true" size="auto"
            append-to-body @close="close">
            <div class="drawer-content" v-loading="dataLoading">
                <el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
                    <el-form-item prop="contentType" required>
                        <span slot="label">内容形式：<small>达人通过选择的内容形式进行推广</small></span>
                        <el-radio-group v-model="formData.contentType">
                            <el-radio :label="1" border>仅短视频</el-radio>
                            <el-radio :label="2" border>仅直播间</el-radio>
                            <el-radio :label="3" border>短视频和直播间</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item prop="ratio">
                        <span slot="label">佣金比例：<small>1% - 29%之间</small></span>
                        <el-input-number style="width: calc(100% - 20px);" v-model="formData.ratio" :min="1" :max="80"
                            :controls="false" :precision="2"></el-input-number> %
                    </el-form-item>

                    <el-form-item v-if="!edit" prop="activityId">
                        <span slot="label">关联演出：<small>只能选择一场演出，且已创建过通用计划的演出不能再次选择</small></span>
                        <div v-if="activity" class="activity">
                            <div class="poster"><el-image :src="activity.poster | coverImage(300, 400)"></el-image></div>
                            <div class="info">
                                <div class="name">{{ activity.title }}</div>
                                <div>{{ activity.cityName }} {{ activity.siteName }}</div>
                                <div>{{ activity.beginShowTime }}</div>
                                <div>
                                    <div><span class="color-info">总库存：</span>{{ activity.totalTicket }}</div>
                                    <div><span class="color-info">已售：</span>{{ activity.sellTicket }}</div>
                                </div>
                                <div><span class="price color-danger">￥{{ activity.minPrice }}</span>起</div>
                            </div>
                        </div>
                
                        <el-button type="primary" plain icon="el-icon-search" @click="$refs.selectActivity.show()">选择演出</el-button>
                    </el-form-item>
                    <div v-else class="color-danger">计划修改只会影响后续的达人推广，之前的推广不受影响</div>
                </el-form>
            </div>
            <div class="drawer-footer">
                <el-button @click="close">取消</el-button>
                <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
            </div>
        </el-drawer>
        <select-activity ref="selectActivity" @onUpdate="setActivity"></select-activity>
    </div>
</template>
<script>
import SelectActivity from './SelectActivity.vue'
const defaultData = {
    id: "",
    contentType: 1,
    ratio: 1,
}
export default {
    components: { SelectActivity },
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            dataLoading: false,
            formData: {
                ...defaultData
            },
            activity: null,
            rules: {
                ratio: [{ required: true, message: "请填写佣金比例" }],
                activityId: [{ required: true, message: "请选择相关演出" }],
            },
            edit: false
        }
    },
    methods: {
        close() {
            this.$refs.formData.resetFields();
            this.drawerShow = false;
            this.formData = {
                ...defaultData
            }
            this.edit = false;
        },
        show(data) {
            if (data) {
                this.edit = true;
                this.formData = {
                    id: data.id,
                    contentType: data.contentType || 1,
                    ratio: data.ratio || 1,
                }
            }
            this.drawerShow = true;
        },
        //选择演出
        setActivity(activity){
            this.activity = activity;
            this.formData.activityId = activity.id;
            this.$refs["formData"].clearValidate('activityId');
        },
        // 提交
        submitForm() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: this.edit ? '/activity/cps/update' : '/activity/cps/save',
                        data: this.edit ? null : { ...this.formData },
                        params: this.edit ? { ...this.formData } : null,
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onUpdate');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.activity {
        display: flex;
        border: 1px #eee solid;
        // width: 370px;
        padding: 15px;
        border-radius: 3px;
        box-shadow: 0 2px 8px #eee;
        line-height: normal;
        margin-bottom: 20px;
        .poster {
            margin-right: 10px;
            background: #f8f8f8;

            .el-image {
                width: 90px;
            }
        }

        .info {
            flex: 1;

            .name {
                font-size: 15px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                height: 36px;
                line-height: 18px;
                margin: 0;
            }

            >div {
                margin-top: 6px;
                font-size: 12px;
                display: flex;
                align-items: flex-end;

                >div {
                    margin-right: 20px;
                }

                .price {
                    font-size: 18px;
                    font-weight: 700;
                    line-height: 1;
                }
            }
        }

    }
</style>